<template>
  <v-container id="contact-detail" fluid tag="section">
    <!-- <CommonLoadingInfinity v-if="loadingInfinity" /> -->
    <base-material-card v-if="loadOrderDetailSuccess && !loadingInfinity" outlined icon="mdi-account-outline" class="overflow-visible pb-7">
      <template v-slot:after-heading>
        <div class="header mobile-hidden">
          <div class="card-order d-flex align-center mt-2">
              <div class="name-order mr-4">
                <div>ĐƠN HÀNG: {{nameCode}}</div>
                <div>PHIẾU THU: {{receiptCode}}</div>
              </div>
              <div class="tab-order" v-show="!_.isEmpty(listTrail)">
                <div class="tab-item-order"  v-for="(item, index) in titleOrder" :key="index" @click="getOrderDetail(item.code), codeOrder = item.code" :class="item.code == codeOrder ? 'active' : ''">
                  {{item.name}}
                  <v-icon  class="pl-2" v-if="item.code == 'ĐHT' && listTrail && listTrail.groupOrderData && listTrail.groupOrderData.length > 1" color="#27AE60"> mdi-shield-check</v-icon>
                  <v-icon  class="pl-2" v-if="item.code == 'ĐHT' && listTrail && listTrail.groupOrderData && listTrail.groupOrderData.length <= 1" color="red"> mdi-alert-box</v-icon>
                </div>
              </div>
            </div>
          </div>
      </template>
      <span @click="clickCancel" class="mobile-show span-icon-custom"><v-icon>mdi-arrow-left</v-icon></span>
      <div class="mobile-show header-mobile">
        <span class="font-weight-light card-title mt-2 span-custom">Tạo đơn hàng</span>
      </div>
      <validation-observer v-slot="{handleSubmit}">
        <div style="position: relative" class="mobile-hidden">
          <div class="header-group-btn">
            <v-btn
              color="primary"
              class="mb-2"
              @click="confirmPayment()"
              v-if="checkAuthorization('order-payment_read') && (contactStatus.type == 'T4' || contactStatus.type == 'C4') && codeOrder !='ĐHT'"
            >
              Xác nhận thanh toán
            </v-btn>

            <v-btn
              color="primary"
              class="mb-2"
              @click="showAccount()"
              v-if="checkAuthorization('order-contact_read') && (contactStatus.type == 'T5' || contactStatus.type == 'C5') && codeOrder !='ĐHT'"
            >
              Xem tài khoản
            </v-btn>

            <v-btn v-if="checkAuthorization('contact_read') && checkAuthorization('order_update') && codeOrder !='ĐHT'"
              color="warning"
              class="mb-2"
              @click="clickDetailContact">
              Chi tiết khách hàng
            </v-btn>

            <v-btn
              v-if="checkAuthorization('every-order_read') && codeOrder !='ĐHT' || (!idsOrderContactStatusFinish.includes(contactStatus.id) && checkAuthorization('order_update') && checkAuthCtvUpdate(contactStatus.type)) && codeOrder !='ĐHT'"
              color="info"
              class="mb-2"
              @click.prevent="handleSubmit(clickUpdateOrder)"
              :disabled="codeOrder =='ĐC' && disable"
            >
              Sửa đơn
            </v-btn>

            <v-btn
              v-if="!idsOrderContactStatusFinish.includes(contactStatus.id) && checkAuthorization('order_delete') && checkAuthCtvUpdate(contactStatus.type) && codeOrder !='ĐHT'"
              color="secondary"
              class="mb-2"
              :disabled="!isShow"
              @click="clickCancelOrder"
            >
              Huỷ đơn
            </v-btn>
             <v-btn
              color="#1782FF"
              class="mb-2"
              @click.prevent="handleSubmit(beforeUpdate)"
              v-if="codeOrder =='ĐHT' && listTrail && listTrail.groupOrderData.length <= 1"
            >
             Tạo đơn hoàn tất
            </v-btn>
             <v-btn
              color="#1782FF"
              class="mb-2"
               @click.prevent="handleSubmit(clickUpdateOrder)"
              v-if="codeOrder =='ĐHT' && listTrail && listTrail.groupOrderData.length > 1"
              :disabled="(contactStatus.type == 'T5' || contactStatus.type == 'C5' || contactStatus.type == 'T4' || contactStatus.type == 'C4') && !checkAuthorization('order-ctv-create_read')"
            >
              Sửa đơn
            </v-btn>

            <v-btn color="success" class="mb-2" @click="clickCancel">Thoát</v-btn>

          </div>
        </div>
        <div style="position: relative" class="mobile-show">
          <v-row class="ma-0">
            <v-col cols="6" class="pa-1" v-if="checkAuthorization('order-payment_read') && (contactStatus.type == 'T4' || contactStatus.type == 'C4')">
              <v-btn
                color="primary"
                class="mr-0 pa-1"
                width="100%"
                height="30px"
                @click="confirmPayment()"
              >
                Xác nhận thanh toán
              </v-btn>
            </v-col>

            <v-col cols="6" class="pa-1" v-if="checkAuthorization('order-contact_read') && (contactStatus.type == 'T5' || contactStatus.type == 'C5')">
              <v-btn
                color="primary"
                class="mr-0 pa-1"
                width="100%"
                height="30px"
                @click="showAccount()"
              >
                Xem tài khoản
              </v-btn>
            </v-col>

            <v-col cols="6" class="pa-1" v-if="checkAuthorization('contact_read') && checkAuthorization('order_update')" >
              <v-btn
                color="warning"
                class="mr-0 pa-1"
                width="100%"
                height="30px"
                @click="clickDetailContact">
                Chi tiết khách hàng
              </v-btn>
            </v-col>

            <v-col cols="6" class="pa-1" v-if="checkAuthorization('every-order_read') || (allowUpdate && !idsOrderContactStatusFinish.includes(contactStatus.id) && checkAuthorization('order_update') && checkAuthCtvUpdate(contactStatus.type))">
              <v-btn
                v-if="isReadOnly"
                color="info"
                class="mr-0 pa-1"
                width="100%"
                height="30px"
                @click="isReadOnly = !isReadOnly"
              >
                Sửa đơn
              </v-btn>
              <v-btn
                v-else
                color="info"
                class="mr-0 pa-1"
                width="100%"
                height="30px"
                @click.prevent="handleSubmit(clickUpdateOrder)"
              >
                Lưu lại
              </v-btn>
            </v-col>

            <v-col cols="6" class="pa-1" v-if="allowUpdate && !idsOrderContactStatusFinish.includes(contactStatus.id) && checkAuthorization('order_delete') && checkAuthCtvUpdate(contactStatus.type)">
              <v-btn
                color="secondary"
                class="mr-0 pa-1"
                width="100%"
                height="30px"
                :disabled="!isShow"
                @click="clickCancelOrder"
              >
                Huỷ đơn
              </v-btn>
            </v-col>
          </v-row>
        </div>
        <v-row :class="stepOrder===3 ? 'active-step-3' : ''">
          <v-col v-if="stepOrder > 1 && $route.params.id >= ORDER_ID" cols="12" sm="9">
            <order-card
              :key="keyOfOrderCard"
              :contactStatus="contactStatus"
              :shippingAddress="shippingAddress"
              :contactStatusList="contactStatusList"
              :contentOrder="contentOrder"
              :courseRegisters="courseRegisters"
              :childCustomers="childCustomers"
              :stepOrder="stepOrder"
              :showChat="showChat"
              :isReadOnly="isReadOnly"
              :contactId="contactId"
              :codeOrder="codeOrder"
              :listTrail="listTrail"
              ref="child"
              :mode="'edit'"
              :disable="disable"
              :status-order-completed="statusOrderCompleted"
            />
          </v-col>
          <v-col v-if="stepOrder > 1 && $route.params.id < ORDER_ID" cols="12" sm="9">
            <order-card-two
              :key="keyOfOrderCard"
              :contactStatus="contactStatus"
              :shippingAddress="shippingAddress"
              :contactStatusList="contactStatusList"
              :contentOrder="contentOrder"
              :courseRegisters="courseRegisters"
              :childCustomers="childCustomers"
              :stepOrder="stepOrder"
              :showChat="showChat"
              :isReadOnly="isReadOnly"
              :contactId="contactId"
              :codeOrder="codeOrder"
              :listTrail="listTrail"
              ref="child"
              :mode="'edit'"
              :disable="disable"
            />
          </v-col>
          <v-col cols="12" sm="3">
            <address-card
              :shippingAddress="shippingAddress"
              :provinces="provinces" :showChat="showChat"
              :contentOrder="contentOrder"
              :isReadOnly="isReadOnly"
            />
            <template v-if="typeSystem  && isCheckIeltsY_T || isCheckIeltsY_GS && typeSystem">
              <validation-provider v-slot="{ errors }" name="Trường đã chọn">
                <v-autocomplete
                    v-model="schoolId"
                    :items="listSchool"
                    clearable
                    item-text="school_name"
                    item-value="id"
                    label="Trường đã chọn"
                    :error-messages="errors"
                />
              </validation-provider>
            </template>
          </v-col>
        </v-row>
      </validation-observer>
      <common-voice-call :mobile="mobile" v-if="(mobile ? true : false)" />
    </base-material-card>
    <v-dialog v-model="showModalCall" max-width="500" persistent></v-dialog>

    <order-dialog
      :dialog="updateDialog"
      :courseRegisters="courseRegisters"
      :childCustomers="childCustomers"
      @closeModal="closeModal"
      :dataDialog="dataDialog"
      :provinces="provinces"
      @orderAction="clickUpdateOrder"
      :listProductLearnType="listProductLearnType"
      :checkEndDate="checkEndDate"/>
  </v-container>
</template>

<script>
import { contactDetail, contactStatus, idsOrderContactStatusFinish, listActiveTypeOrder } from '../../helpers/constants';
import AddressCard from './components/AddressCard';
import OrderCard from './components/OrderCard';
import OrderCardTwo from './components/OrderCardTwo';
import OrderDialog from './components/OrderDialog'
import RepositoryFactory from '../../repositories/RepositoryFactory';
import TokenService from '../../helpers/token'
import { moduleSchoolLevel } from '@/helpers/constants';
import moment from 'moment';
const ContactRepository = RepositoryFactory.get('contact');
const ProductRepository = RepositoryFactory.get('product');
const ContactStatusRepository = RepositoryFactory.get('contact_status');
const AddressRepository = RepositoryFactory.get('address');
const OrderRepository = RepositoryFactory.get('order');
const ORDER_ID = process.env.VUE_APP_ORDER_ID || '327159';
const SchoolRepository = RepositoryFactory.get('school');

export default {
  components: {AddressCard, OrderCard, OrderDialog, OrderCardTwo},
  data() {
    return {
      statusOldDeposit: null,
      listActiveTypeOrder,
      listProductLearnType: [],
      courseRegisters: [],
      mainCustomer: {},
      stepOrder: 2,
      provinces: [],
      contactStatusList: [],
      contactStatus: {},
      shippingAddress: {
        xaName: '',
        tinhName: '',
        huyenName: '',
        receiver: '',
        phone: '',
        email: '',
        tinhId: 0,
        xaId: 0,
        huyenId: 0,
        detailAddress: ''
      },
      contentOrder: {
        paidAmount: 0,
        products: [],
        description: '', //ghi chu don hang,
        statusId: '',
        paymentType: '',
        isDetail: true,
        totalPrice: 0,
      },
      idsOrderContactStatusFinish: idsOrderContactStatusFinish,
      contactId: '',
      loadOrderDetailSuccess: false,
      loadContactDetailSuccess: false,
      showChat: false,
      childCustomers: [],
      showModalCall: false,
      mobile: '',
      dataUpdate: {},
      dataDialog: {},
      isReadOnly: false,
      updateDialog: false,
      allowUpdate: false,
      checkEndDate: true,
      isShow: false,
      isTimerRunning: '',
      listOrderDisable: [],
      listOrderTutor: [],
      keyOfOrderCard: 0,
      titleOrder: [
        {
          id: 1,
          name: 'Đơn cọc',
          code: 'ĐC'
        },
        {
          id: 2,
          name: 'Đơn hoàn tất',
          code: 'ĐHT'
        },
      ],
      codeOrder: 'ĐC',
      listTrail: {},
      nameCode: '',
      paymentTypeĐC : 0,
      disable: false,
      listContactStatus: [],
      contactStatusId: null,
      ORDER_ID: ORDER_ID,
      schoolId: '',
      listSchool: [],
      attrs: [
        'id',
        'school_name',
        'school_code'
      ],
      isCheckIeltsY_GS: false,
      isCheckIeltsY_T: false,
      moduleSchoolLevel,
      statusOrderCompleted: {},
      versionOrder: null,
      loadingInfinity: false,
      receiptCode: null,
      statusObj: {
        init: 'Khởi tạo',
        in_progress: 'Chờ thanh toán',
        final_success: 'Thành công',
        final_return: 'Hoàn',
        final_cancel: 'Hủy',
      },
      statusText: null,
    };
  },
  async created() {
    await this.checkVersionOrder()
    if (this.versionOrder == 2) {
      this.$router.push({name: 'OrderDetailNew', params: { id: this.contactId}, query: {order: this.$route.params.id},});
      return;
    }
    Bus.$on('checkIeltsY-GS', (data) => {
      this.isCheckIeltsY_GS = data
    });
    Bus.$on('checkIeltsY-T', (data) => {
      this.isCheckIeltsY_T = data
    });
    if (this.idsOrderContactStatusFinish.includes(this.contactStatus.id)) {
      this.stepOrder = 3;
    }
    if (this.$route.query.mobile) {
      // this.isReadOnly = true
      if (typeof(this.$route.query.allowUpdate) == 'boolean') {
        this.allowUpdate = this.$route.query.allowUpdate
      } else {
        this.allowUpdate = this.$route.query.allowUpdate == 'true' ? true : false
      }
    } else {
      this.isReadOnly = !this.checkAuthorization('order_update')
    }
    if(this.typeSystem) { //check nếu là ielts y
      await  this.getListSchool()
    }
    await this.getProductComboList(); //1st
    await this.getOrderDetail();
    // await this.getContactDetail();
    await this.getProvinces();
    await this.getContactStatusList();

    Bus.$on('close-voice-call-form', () => {
      this.showModalCall = false;
      this.mobile = '';
      this.appointmentId = 0;
    });

    this.isTimerRunning = setInterval(this.showButtonCancelOrder, 1000);
    if(this.codeOrder == 'ĐC' && (this.contactStatus.type == 'T5' || this.contactStatus.type == 'C5' || this.contactStatus.type == 'T4' || this.contactStatus.type == 'C4') && !this.checkAuthorization('order-ctv-create_read')) {
      this.disable = true
    }else if(this.checkAuthorization('order-ctv-create_read')){
      this.disable = false
    }

  },
  computed: {
    typeSystem() {
      return this.$store.state.module.typeId == 6 && this.$store.state.module.schoolLevelId == 7
    },
    moduleschoolLevelId() {
      return this.$store.state.module.schoolLevelId
    }
  },
  beforeDestroy() {
    Bus.$off('checkIeltsY-GS')
    Bus.$off('checkIeltsY-T')
  },
  methods: {
    attrsDataUrl(dataRequest) {
      let data = "";
      dataRequest.forEach((item) => {
        data += "&attrs[]=" + item;
      });
      return data;
    },
    async getListSchool() {
      const filter = { limit: 1000 , 'filters[$eq__status]': 1 }
      if([this.moduleSchoolLevel.STATION,this.moduleSchoolLevel.SCHOOL].includes(this.moduleschoolLevelId)) {
        filter[`filters[$eq__type]`] = this.moduleschoolLevelId === this.moduleSchoolLevel.STATION ? 'station' : 'school'
      }
      const respond =await SchoolRepository.listSchoolApi(this.attrsDataUrl(this.attrs),filter);
      if(respond.success){
        this.listSchool = _.get(respond, 'data', [])
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', '')
        });
      }
    },
    clickDetailContact() {
      this.$router.push({
        name: 'ContactDetail',
        params: {
          id: this.contactId || 0
        }
      });
    },
    async clickCancelOrder() {
      this.$swal({
          title: 'Huỷ đơn hàng',
          text: 'Bạn có thực sự muốn huỷ đơn hàng ?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Đồng ý',
          cancelButtonText: 'Hủy bỏ',
          closeOnClickOutside: false,
          allowOutsideClick: false
        }).then(async (result) => {
          if (!result.value) {
            return;
          }
          let charFirstType = _.get(this.contactStatus, 'type', 'T').charAt(0) || 'T';
          let changeStatusId = charFirstType === 'T' ? contactStatus.T2_HUY : contactStatus.C2_HUY;
          const loader = this.$loading.show();
          const respond = await OrderRepository.changeStatus(this.$route.params.id, {statusId: changeStatusId});
          loader.hide()
            if (_.get(respond, 'success', false)) {
              this.$swal({
                title: 'Huỷ đơn hàng thành công !',
                confirmButtonText: 'Đồng ý',
              },
              ).then(() => {
                this.clickCancel();
              })
            } else {
              this.$swal({
                type: 'error',
                title: 'Lỗi !',
                text: _.get(respond, 'message', ''),
              })
            }
        })
    },
    async getReceipt() {
      const res = await OrderRepository.getHistory({ order_code: this.nameCode });
      if (res && res.data.length) {
        this.receiptCode = res.data[0].code;
        this.statusText = this.statusObj[res.data[0].status]
      }
    },
    async getOrderDetail(val) {
      let respond
      if(_.isEmpty(this.listTrail)) {
        respond = await OrderRepository.detail(this.$route.params.id);
        this.nameCode =  _.get(respond.data, 'code', '')
        const respondTrail = await OrderRepository.detailV2(this.$route.params.id);
        this.listTrail = _.get(respondTrail, 'data', {})
        this.getReceipt();
        if(respondTrail && respondTrail.data && respondTrail.data.groupOrderData) {
          const findOrder = _.filter(respondTrail.data.groupOrderData, (o) => {
          return o.orderId == this.$route.params.id;
          });
          this.codeOrder = findOrder[0].orderType == 1 ? 'ĐC' : 'ĐHT';
        }
        const respondTrailHT = _.get(respondTrail, 'data.groupOrderData', []);
        if(respondTrailHT.length == 2) {
          const ĐHT = await OrderRepository.detail(respondTrail.data.groupOrderData[1].orderId)
            this.statusOrderCompleted = ĐHT.data ? ĐHT.data.contactStatus : {}
            if((['T5', 'C5', 'T4', 'C4'].includes(ĐHT.data.contactStatus.type)) && !this.checkAuthorization('order-ctv-create_read')) {
            this.disable = true
          }else if(this.checkAuthorization('order-ctv-create_read')){
            this.disable = false
          }
        }
        if(this.$route.query.codeOrder && this.$route.query.codeOrder == 2) {
          this.codeOrder = 'ĐHT'
          this.nameCode = ''
        }
      }else {
        if(val == 'ĐC') {
          const respondTrail = await OrderRepository.detailV2(this.listTrail.groupOrderData[0].orderId);
          this.listTrail = _.get(respondTrail, 'data', {})
          respond = await OrderRepository.detail(this.listTrail.groupOrderData[0].orderId);
          this.nameCode =  _.get(respond.data, 'code', '');
          this.getReceipt();
          //   let route = this.$router.resolve({
          //   name: 'OrderDetail',
          //   params: {
          //     id: this.listTrail.groupOrderData[0].orderId,
          //   },
          //   query: {
          //     orderList: true,
          //   },
          // });
          // window.open(route.href, "_self")
        }
        if(val == 'ĐHT') {
          const result = _.some(this.listTrail.groupOrderData, ['orderType', 2])
          if(!result) {
            this.nameCode = '';
            this.receiptCode = null;
            this.contactStatus = {
              type: '',
              name: ''
            }
            this.contentOrder.description = '';
            return
          }
          const respondTrail = await OrderRepository.detailV2(this.listTrail.groupOrderData[1].orderId);
          this.listTrail = _.get(respondTrail, 'data', {})
          respond = await OrderRepository.detail(this.listTrail.groupOrderData[1].orderId);
          this.nameCode =  _.get(respond.data, 'code', '');
          this.getReceipt();
          // let route = this.$router.resolve({
          //   name: 'OrderDetail',
          //   params: {
          //     id: this.listTrail.groupOrderData[1].orderId,
          //   },
          //   query: {
          //     orderList: true,
          //   },
          // });
          // window.open(route.href, "_self")
        }
      }
      this.loadOrderDetailSuccess = false;
      const loader = this.$loading.show();

      loader.hide();
      if (_.get(respond, 'success', false) && _.get(respond, 'data', null)) {
        this.loadOrderDetailSuccess = true;
        const dataOrderDetail = respond.data;
        this.contactId = _.get(dataOrderDetail, 'contactId', '');
        if(this.$route.query.codeOrder && this.$route.query.codeOrder == 2 && this.codeOrder == 'ĐHT') {
          this.contactStatus = {
              type: '',
              name: ''
          }
        }else {
          this.contactStatus = _.get(dataOrderDetail, 'contactStatus', {});
        }
        if(this.codeOrder == 'ĐC' && (this.contactStatus.type == 'T5' || this.contactStatus.type == 'C5' || this.contactStatus.type == 'T4' || this.contactStatus.type == 'C4') && !this.checkAuthorization('order-ctv-create_read')) {
          this.disable = true

        }else if(this.checkAuthorization('order-ctv-create_read')){
          this.disable = false
        }
        if(this.codeOrder == 'ĐC') {
            this.statusOldDeposit = { ...this.contactStatus }
        }
        Object.assign(this.shippingAddress, {
          receiver: dataOrderDetail.receiver,
          phone: dataOrderDetail.phone,
          email: dataOrderDetail.email,
          tinhId: dataOrderDetail.tinhId,
          xaId: dataOrderDetail.xaId,
          huyenId: dataOrderDetail.huyenId,
          detailAddress: dataOrderDetail.detailAddress
        });
        this.schoolId = dataOrderDetail.schoolIds.length > 0 ? dataOrderDetail.schoolIds[0]: ''
        const products = [];
        _.get(dataOrderDetail, 'combos', []).forEach(dataCombo => {
          products.push({
            productId: `combo-${dataCombo.comboId}`,
            quantity: dataCombo.quantity,
            price: dataCombo.price,
            customerId: dataCombo.customerId,
            intoMoney: dataCombo.intoMoney ? +dataCombo.intoMoney : (+dataCombo.price) * (+dataCombo.quantity),
            productType: dataCombo.productType,
            activeTypeOrder: +dataCombo.activeType,
            activeDate: dataCombo.activeDate,
            listActiveType: dataCombo && dataCombo.listActiveType ? this.listActiveTypeOrder.filter(item => dataCombo.listActiveType.includes(item.id)) : [],
            isDisable : true
          });
        });

        _.get(dataOrderDetail, 'products', []).forEach(dataProduct => {
          products.push({
            productId: `product-${dataProduct.productId}`,
            quantity: dataProduct.quantity,
            price: dataProduct.price,
            customerId: dataProduct.customerId,
            intoMoney: +dataProduct.intoMoney,
            product: dataProduct.product,
            orderType: +dataProduct.orderType,
            productType: dataProduct.productType,
            activeTypeOrder: +dataProduct.activeType,
            activeDate: dataProduct.activeDate,
            listActiveType: dataProduct && dataProduct.listActiveType ? this.listActiveTypeOrder.filter(item => dataProduct.listActiveType.includes(item.id)) : [],
            isDisable : true
          });
        });
        Object.assign(this.contentOrder, {
          paymentType: dataOrderDetail.paymentType || '',
          statusId: dataOrderDetail.statusId,
          description: dataOrderDetail.description,
          paidAmount: dataOrderDetail.paidAmount,
          products,
          createdAt: dataOrderDetail.createdAt,
          noteSortClass: dataOrderDetail.noteSortClass,
          noteSortClassId: dataOrderDetail.noteSortClassId,
          totalPrice: dataOrderDetail.totalPrice
        });
        this.childCustomers = _.get(dataOrderDetail, 'contact.customers', []).filter(c => c.position === 'child');
        this.contactStatusId = _.get(dataOrderDetail, 'contact.statusId', null)
        this.checkOrderStudent()
      } else {
        this.loadOrderDetailSuccess = false;
      }
    },
    mappingData(dataUpdate, res) {
      const oldData = {...dataUpdate};
      const shippingAddressUpdate = {
        receiver: _.get(res.data, 'receiver', ''),
        phone: _.get(res.data, 'phone', ''),
        email: _.get(res.data, 'email', ''),
        tinhId: _.get(res.data, 'tinhId', ''),
        huyenId: _.get(res.data, 'huyenId', ''),
        xaId: _.get(res.data, 'xaId', ''),
        detailAddress: _.get(res.data, 'detailAddress', '')
      };
      oldData.paymentType =  _.get(res.data, 'paymentType', '');
      oldData.statusId = +_.get(res.data, 'statusId', 0);
      oldData.paymentType = _.get(res.data, 'paymentType', 'BANK');
      oldData.description = _.get(res.data, 'description', '');
      oldData.paidAmount = +_.get(res.data, 'paidAmount', 0);
      oldData.shippingAddress = shippingAddressUpdate;
      // oldData.noteSortClass = _.trim(res.data.noteSortClass || '' );
      oldData.noteSortClassId = res.data.noteSortClassId;
      delete oldData.noteSortClass;
      return oldData;
    },
    async clickUpdateOrder() {
      const rscheckUPdate = this.beforeUpdateOrder();
      if (!rscheckUPdate) {
        this.$swal({
          title: 'Vui lòng đưa contact về kho T hoặc kho C để sửa đơn',
        })
        return
      };
      let firstIndexParent = -1;
      let fullNameParent = '';
      let contentOrderTutor = this.$refs.child.orderGS.concat(this.$refs.child.orderT)
      if(_.isEmpty(contentOrderTutor)) {
        this.$swal.fire('Chưa có sản phẩm nào!')
        return
      }
      const checkOrder = _.some(contentOrderTutor, (item) => {
          return item.customerId === '' || item.orderType === '' || item.productId === "" || item.orderType === ''
      });
      const checkActive = _.some(contentOrderTutor, (item) => {
        return item.activeTypeOrder === ''
      });
      if(checkOrder) {
        this.$swal.fire('Thông tin đơn hàng bị thiếu thông tin. Vui lòng kiểm tra lại!');
        return
      }
      if(checkActive) {
        this.$swal.fire('Vui lòng chọn phương thức kích hoạt');
        return
      }
      if(this.codeOrder == 'ĐC') {
          if(this.contactStatus.type == 'T5' || this.contactStatus.type == 'C5') {
              if(this.$refs.child.totalPriceOld !== (this.$refs.child.totalPriceT + this.$refs.child.totalPriceGS)) {
                  this.$swal({
                      title: 'Vui lòng không thay đổi giá trị đơn hàng cũ!',
                      icon: "warning",
                  })
                  return
              }
          }
      }
        if(this.codeOrder == 'ĐHT') {
            if(this.statusOldDeposit && this.statusOldDeposit.type == 'T5' ||  this.statusOldDeposit && this.statusOldDeposit.type == 'C5') {
                if(this.$refs.child.totalPriceOld !== (this.$refs.child.totalPriceT + this.$refs.child.totalPriceGS)) {
                    this.$swal({
                        title: 'Vui lòng không thay đổi giá trị đơn hàng cũ!',
                        icon: "warning",
                    })
                    return
                }
            }
        }

      const contentOrderUpdate = {
        description: _.get(this.contentOrder, 'description', ''),
        statusId: this.contentOrder.statusId,
        paymentType: this.contentOrder.paymentType,
        paidAmount: !this.contentOrder.paidAmount ? 0 : Number(this.contentOrder.paidAmount),
        totalPrice: !this.contentOrder.totalPrice ? 0 : Number(this.contentOrder.totalPrice),
        noteSortClass: _.get(this.contentOrder, 'noteSortClass', ''),
        noteSortClassId: this.contentOrder.noteSortClassId,
      };
      contentOrderUpdate.products = contentOrderTutor.map(product => {
        const productTemp = { ...product };
        const productArray = productTemp.productId.split('-');
        const customerChild = this.childCustomers.find(
          customer => customer.customerId == product.customerId
        );
        return {
          productId: +productArray[1],
          productType: productArray[0],
          quantity: +product.quantity,
          customerId: +product.customerId,
          // price: product.price,
          price: Math.round(+product.intoMoney / +product.quantity),
          orderId: parseInt(this.$route.params.id),
          intoMoney: +product.intoMoney,
          orderType: +product.orderType,
          activeType: +product.activeTypeOrder,
          activeDate: product.activeDate,
        };
      });
      // let totalPrice = contentOrderUpdate.products.reduce((accumulator, product) => {return accumulator + _.get(product, 'price', 0) * _.get(product, 'quantity', 0)}, 0) || 0
      let totalPrice = contentOrderUpdate.products.reduce((accumulator, product) => {
        return accumulator + parseInt(_.get(product, 'intoMoney', 0))
      }, 0) || 0
      const shippingAddressUpdate = {
        receiver: _.get(this.shippingAddress, 'receiver', ''),
        phone: _.get(this.shippingAddress, 'phone', ''),
        email: _.get(this.shippingAddress, 'email', ''),
        tinhId: _.get(this.shippingAddress, 'tinhId', ''),
        huyenId: _.get(this.shippingAddress, 'huyenId', ''),
        xaId: _.get(this.shippingAddress, 'xaId', ''),
        detailAddress: _.get(this.shippingAddress, 'detailAddress', '')
      };
      const dataUpdate = {
        statusId: +_.get(contentOrderUpdate, 'statusId', 0),
        paymentType: _.get(contentOrderUpdate, 'paymentType', 'BANK'),
        description: _.get(contentOrderUpdate, 'description', ''),
        paidAmount: +_.get(contentOrderUpdate, 'paidAmount', 0),
        products: _.get(contentOrderUpdate, 'products', []),
        shippingAddress: shippingAddressUpdate,
        noteSortClass: _.trim(contentOrderUpdate.noteSortClass || '' ),
        noteSortClassId: contentOrderUpdate.noteSortClassId,
        totalPrice: totalPrice,
        schoolIds: this.schoolId ? [this.schoolId] : [],
      };

      this.loading = this.$loading.show()
      let res = await ContactRepository.checkCustomerBeforeCreate(dataUpdate.products)
      if (res.success) {
        // delete property orderId
       dataUpdate.products.forEach(item => {
          delete item.orderId
        });

        delete this.dataUpdate.contactId;
        delete this.dataUpdate.listEndDate;
        let response
        if(this.$refs.child.statusDepositOne || this.$refs.child.statusDepositTwo) {
          dataUpdate.totalPriceOfGroup = (this.$refs.child.totalPriceT + this.$refs.child.totalPriceGS)
          if(this.$refs.child.statusDepositTwo) {
            dataUpdate.trailProduct = this.$refs.child.orderHT.map(s => {
              return {
                trailLessons: Number(s.quantity),
                productId: s.id,
                money: s.intoMoney,
                customerId: s.customerId,
                numberOfSection: s.numberOfSection,
              }
            })
          }
          if(this.codeOrder == 'ĐHT' && this.listTrail && this.listTrail.groupOrderData.length <= 1) {
            dataUpdate.totalPrice = this.$refs.child.restPrice
            dataUpdate.orderType = this.codeOrder == 'ĐHT' ? 2 : 1
            dataUpdate.contactId = this.contactId
            delete dataUpdate.statusId
            delete dataUpdate.noteSortClassId
            dataUpdate.prevOrderId = this.listTrail.groupOrderData[0].orderId
            response = await OrderRepository.createV2(dataUpdate);
          }else {
            if(this.codeOrder == 'ĐC') {
              response = await OrderRepository.updateV2(
                this.listTrail.groupOrderData[0].orderId,
                { ...dataUpdate,
                  totalPrice: this.$refs.child.restPrice,
                  orderType: 1
                }
              );
              if(this.listTrail.groupOrderData.length == 2) {
                let res = await OrderRepository.detail(this.listTrail.groupOrderData[1].orderId);
                const newDataUpdate = this.mappingData(dataUpdate, res);
                await OrderRepository.updateV2(
                this.listTrail.groupOrderData[1].orderId,
                { ...newDataUpdate,
                  totalPrice: (this.$refs.child.totalPriceT + this.$refs.child.totalPriceGS)  - this.$refs.child.restPrice,
                  orderType: 2
                }
                );
              }
            }
            if(this.codeOrder == 'ĐHT') {
              response = await OrderRepository.updateV2(
                this.listTrail.groupOrderData[1].orderId,
                { ...dataUpdate,
                  totalPrice: this.$refs.child.restPrice,
                  orderType: 2
                }
              );
              if(this.listTrail.groupOrderData.length == 2) {
                let res = await OrderRepository.detail(this.listTrail.groupOrderData[0].orderId);
                const newDataUpdate = this.mappingData(dataUpdate, res)
                await OrderRepository.updateV2(
                this.listTrail.groupOrderData[0].orderId,
                { ...newDataUpdate,
                  totalPrice: (this.$refs.child.totalPriceT + this.$refs.child.totalPriceGS)  - this.$refs.child.restPrice,
                  orderType: 1
                }
                );
              }
            }
          }
        }else {
          response = await OrderRepository.update(
            this.$route.params.id,
            dataUpdate
          );
        }

        this.loading.hide();
        if (response.error) {
          this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: _.get(response, 'message', '')
          });
        } else if (_.get(response, 'data.isExist', false)) {
          this.$swal({
            title: 'Cập nhật đơn hàng không thành công, Số điện thoại người nhận đã tồn tại!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Xem contact',
            closeOnConfirm: false,
            cancelButtonText: 'Huỷ Bỏ'
          }).then(result => {
            if (result.value) {
              return this.$router.push({
                name: 'ContactDetail',
                params: {
                  id: _.get(response, 'data.contactId', null)
                }
              });
            }
          });
        } else {
          this.$swal({
            title: `${(this.$refs.child.statusDepositOne || this.$refs.child.statusDepositTwo) && this.codeOrder == 'ĐHT' && this.listTrail && this.listTrail.groupOrderData.length <= 1 ? 'Tạo Đơn hàng thành công!!!' : 'Cập nhật Đơn hàng thành công!!!'}`,
            confirmButtonText: 'Đồng ý'
          }).then(() => {
            if (this.$route.query.orderList) {
              return this.$router.push({
                name: 'OrderList'
              });
            }
            return this.$router.push({
              name: 'ContactOrderList',
              params: {
                id: this.contactId || 0
              }
            });
          });
        }
      } else {
        this.loading.hide()
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(res, 'message', '')
        })
      }
    },
    async getProvinces() {
      const respond = await AddressRepository.provinces({ limit: 100 });
      if (_.get(respond, 'success', false)) {
        this.provinces = _.get(respond, 'data', []).filter(data => data.id != 0);
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', '')
        });
      }
    },
    async getProductComboList() {
      const respond = await ProductRepository.listAll({ limit: 100 });
      if (_.get(respond, 'success', false)) {
        const products = _.get(respond, 'data.products', []).map(product => {
          const productTemp = product;
          productTemp.idTemp = `product-${product.id}`;
          return productTemp;
        });
        const combos = _.get(respond, 'data.combos', []).map(combo => {
          const comboTemp = combo;
          comboTemp.idTemp = `combo-${combo.id}`;
          comboTemp.price = _.get(comboTemp, 'products', []).reduce(
            (accumulator, product) => {
              return accumulator + _.get(product, 'price', 0);
            },
            0
          );
          return comboTemp;
        });
        this.courseRegisters = [
          { header: 'Sản Phẩm' },
          ...products,
          { divider: true },
          { header: 'Combo' },
          ...combos
        ];
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', '')
        });
      }
    },
    async getContactStatusList() {
      const loading = this.$loading.show();
      const typeArray = ['T3', 'C3'];
      const response = await ContactStatusRepository.list({});
      this.listContactStatus = _.get(response, 'data', [])
      loading.hide();
      if (response.success) {
        const contactStatusList = [];
        _.get(response, 'data', []).forEach(contactStatus => {
          if (typeArray.includes(_.get(contactStatus, 'type', ''))) {
            _.get(contactStatus, 'data', []).forEach(data => {
              contactStatusList.push({
                type: contactStatus.type,
                id: _.get(data, 'id', 0),
                name: _.get(data, 'name', 0)
              });
            });
          }
        });
        this.contactStatusList = contactStatusList;
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(response, 'message', '')
        });
      }
    },
    clickCancel() {
      if (this.$route.query.orderList) {
        return this.$router.push({
          name: 'OrderList'
        });
      }
      this.$router.push({
        name: 'ContactOrderList',
        params: {
          id: this.contactId || 0
        }
      });
    },
    clickStep() {
      this.contentOrder.paidAmount = this.contentOrder.paidAmount << 0;
      if (this.stepOrder === 2) {
        // Combine the same products and customers
        let objectCheckProducts = {};
        const productsTemp = [];
        let indexProductsTemp = 0;
        _.get(this.contentOrder, 'products', []).forEach(product => {
          const idTemp = product.productId + '_' + product.customerId;
          const indexTemp = objectCheckProducts[idTemp];
          if (indexTemp == null) {
            objectCheckProducts[idTemp] = indexProductsTemp;
            indexProductsTemp++;
            productsTemp.push({ ...product });
          } else {
            productsTemp[indexTemp].quantity += +product.quantity;
          }
        });
        // End Combine the same products and customers
        this.contentOrder.products = productsTemp;
      }
      this.stepOrder = this.stepOrder + 1;
    },
    beforeUpdateOrder() {
      const flatListStatus = _.flatMap(this.listContactStatus, ({ data }) =>
        _.map(data, statusData => statusData)
      );

      const foundStatusID = _.find(flatListStatus, ['id', this.contactStatusId]);
      if(foundStatusID && foundStatusID.store && foundStatusID.store.toUpperCase() === 'M') {
        return false
      }

      return true;
    },
    async beforeUpdate() {
      const rscheckUPdate = this.beforeUpdateOrder();
      if (!rscheckUPdate) {
        this.$swal({
          title: 'Vui lòng đưa contact về kho T hoặc kho C để tạo đơn',
        })
        return
      };
      let firstIndexParent = -1;
      let fullNameParent = '';
      if(this.statusOldDeposit && this.statusOldDeposit.type == 'C5' || this.statusOldDeposit && this.statusOldDeposit.type == 'T5') {
          if(this.$refs.child.totalPriceOld !== (this.$refs.child.totalPriceT + this.$refs.child.totalPriceGS)) {
              this.$swal({
                  title: 'Vui lòng không thay đổi giá trị đơn hàng cũ!',
                  icon: "warning",
              })
              return
          }
      }
      const contentOrderUpdate = {
        description: _.get(this.contentOrder, 'description', ''),
        statusId: this.contentOrder.statusId,
        paymentType: this.contentOrder.paymentType,
        paidAmount: !this.contentOrder.paidAmount ? 0 : Number(this.contentOrder.paidAmount),
        totalPrice: !this.contentOrder.totalPrice ? 0 : Number(this.contentOrder.totalPrice),
      };
      contentOrderUpdate.products = this.contentOrder.products.map(product => {
        const productTemp = { ...product };
        const productArray = productTemp.productId.split('-');
        const customerChild = this.childCustomers.find(
          customer => customer.customerId == product.customerId
        );
        return {
          productId: +productArray[1],
          productType: productArray[0],
          quantity: +product.quantity,
          customerId: +product.customerId,
          price: product.price,
          intoMoney: +product.intoMoney,
          orderType: +product.orderType,
          activeType: +product.activeTypeOrder,
          activeDate: product.activeDate,
        };
      });
      let totalPrice = contentOrderUpdate.products.reduce((accumulator, product) => {return accumulator + _.get(product, 'price', 0) * _.get(product, 'quantity', 0)}, 0) || 0
      const shippingAddressUpdate = {
        receiver: _.get(this.shippingAddress, 'receiver', ''),
        phone: _.get(this.shippingAddress, 'phone', ''),
        email: _.get(this.shippingAddress, 'email', ''),
        tinhId: _.get(this.shippingAddress, 'tinhId', ''),
        huyenId: _.get(this.shippingAddress, 'huyenId', ''),
        xaId: _.get(this.shippingAddress, 'xaId', ''),
        detailAddress: _.get(this.shippingAddress, 'detailAddress', '')
      };
      const dataUpdate = {
        statusId: +_.get(contentOrderUpdate, 'statusId', 0),
        paymentType: _.get(contentOrderUpdate, 'paymentType', 'BANK'),
        description: _.get(contentOrderUpdate, 'description', ''),
        paidAmount: +_.get(contentOrderUpdate, 'paidAmount', 0),
        products: _.get(contentOrderUpdate, 'products', []),
        shippingAddress: shippingAddressUpdate,
        totalPrice: totalPrice,
      };
      this.dataUpdate = dataUpdate
      const dataTimeOrderHT = dataUpdate.products.map((s) => {
          const foundProduct = _.find(this.$refs.child.orderT, o2 => `${s.productType}-${s.productId}` == o2.productId && o2.productType !== 'GIA_SU')
          if(foundProduct && (this.$refs.child.statusDepositOne || this.$refs.child.statusDepositTwo)) {
            const newDate =  moment(this.contentOrder.createdAt, 'YYYY-MM-DD HH:mm:ss').add(foundProduct.endMonth, 'months');
            return {
              ...s,
              listEndDate: newDate.format('DD/MM/YYYY'),
              checkDeposit: false
            }
          }else {
            return {
              ...s,
              listEndDate: null
            }
          }

          // if(foundProduct && this.$refs.child.statusDepositTwo){
          //   const newDate =  moment().add(foundProduct.quantity, 'months');
          //   return {
          //     ...s,
          //     listEndDate: newDate.format('DD/MM/YYYY'),
          //     checkDeposit: false
          //   }
          // }

          // if(foundProduct && !this.$refs.child.statusDepositTwo) {
          //   return {
          //     ...s,
          //     listEndDate: foundProduct.endMonth,
          //     checkDeposit: true
          //   }
          // } else if(foundProduct && this.$refs.child.statusDepositTwo){
          //   const newDate =  moment().add(foundProduct.quantity, 'months');
          //   return {
          //     ...s,
          //     listEndDate: newDate.format('DD/MM/YYYY'),
          //     checkDeposit: false
          //   }
          // }else {
          //   return {
          //     ...s,
          //     listEndDate: null
          //   }
          // }
        })
      this.loading = this.$loading.show()
      dataUpdate.contactId = this.contactId
        const productId = []
        dataUpdate.products.forEach(item => {
            productId.push(item.productId)
        })
        const responseProductLearnType = await OrderRepository.getListProductLearnType({ productIds: productId })
        if(responseProductLearnType.success) {
            this.listProductLearnType = responseProductLearnType.data
        }

      dataUpdate.listEndDate = {};
      let response = await OrderRepository.getEndDate(dataUpdate)
      if (response.success) {
        this.checkEndDate = true;
        dataUpdate.products.forEach((item, key) => {
          if(typeof dataUpdate.listEndDate[item.customerId] == 'undefined') {
            dataUpdate.listEndDate[item.customerId] = {}
          }

          // let endDateObject = moment(response.data[item.customerId][item.productId], 'DD/MM/YYYY')
          let endDateRes = response.data[item.customerId][item.productId];

          if(endDateRes.toUpperCase() === 'INVALID DATE') {
            this.checkEndDate = false;
            // return;
          }
          if(item.productId){
            const foundProduct = _.find(dataTimeOrderHT, productId => productId.productId == item.productId)
              let findProduct = this.courseRegisters.find(s => s.id == item.productId)
              let checkName = findProduct?.name.toLowerCase().indexOf('gia hạn') >= 0

              if(foundProduct && foundProduct.listEndDate && response.data[item.customerId][item.productId] != 'Invalid date' && !checkName) {
                dataUpdate.listEndDate[item.customerId][item.productId] = { end_date:response.data[item.customerId][item.productId] ? response.data[item.customerId][item.productId] : foundProduct.listEndDate , checkDeposit: foundProduct.checkDeposit};
              }else {
                dataUpdate.listEndDate[item.customerId][item.productId] = {end_date: response.data[item.customerId][item.productId], checkDeposit: false};
              }
            // dataUpdate.listEndDate[item.customerId][item.productId] = {end_date: response.data[item.customerId][item.productId]};
          }
        })
        this.dataDialog = {
          ...dataUpdate,
          // products: _.get(response, 'data', []),
          shippingAddress: {
            ...this.shippingAddress
          }
        }
        if(this.$refs.child.needMoney && (this.$refs.child.statusDepositOne || this.$refs.child.statusDepositTwo)) {
          this.dataDialog.needMoney = this.$refs.child.needMoney
        }
        this.updateDialog = true
        this.loading.hide()
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(response, 'message', '')
        })
      }
    },
    closeModal() {
      this.updateDialog = false
    },
    confirmPayment() {
      let me = this
      this.$swal({
        title: 'Bạn có chắc chắc đã nhận được tiền học phí của đơn hàng này không?',
        confirmButtonText: 'Xác nhận',
        showCancelButton: true,
        cancelButtonText: 'Hủy'
      }).then(async response => {
        if (response.value) {
          let res = await OrderRepository.confirmPayment({id: me.$route.params.id})
          if (res.success) {
              await me.getOrderDetail()
          }
        }
      })
    },
    showAccount() {
      this.$router.push(`/orders/${this.$route.params.id}/account`)
    },
    checkAuthCtvUpdate(type) {
      if(this.checkAuthorization('order-ctv-create_read')) {
        if (!['T5', 'C5'].includes(type)) {
          return true;
        }
      }
      return !this.checkIncludesT4NT5(type);
    },
    showButtonCancelOrder() {
      if(moment(this.contentOrder.createdAt).format('YYYY-MM-DD HH:mm:ss')  < moment().subtract(1, "minutes").format('YYYY-MM-DD HH:mm:ss')) {
        clearInterval(this.isTimerRunning);
        this.isShow = true;
      } else {
        this.isShow = false
      }
    },
     checkTime(time) {
      return moment(time).valueOf()
    },
    async checkOrderStudent() {
      if (!this.contactId) return
      const responseTutor = await OrderRepository.getTransferOrderStudents(this.contactId)
      if (_.isEmpty(responseTutor.data)) return
      this.listOrderTutor = responseTutor.data
      if (_.isEmpty(this.contentOrder.products)) return
      this.checkDisableOder();
      this.checkDisableDropdown();
      this.keyOfOrderCard++;
    },
    checkDisableOder() {
      for (let i = 0; i < this.contentOrder.products.length; i++) {
        const currentProduct = this.contentOrder.products[i]
        const disabled = _.some(this.listOrderTutor, (currentData) => {
          return  currentProduct.product.monCode == currentData.monCode
            && currentProduct.product.classType == currentData.old_class_type
            && currentProduct.product.teacherType == currentData.old_teacher_type
            && this.checkTime(this.contentOrder.createdAt) < this.checkTime(currentData.created_date)
            && currentProduct.customerId == currentData.customerId
        })
        this.contentOrder.products[i].disable = disabled;
        if (disabled){this.listOrderDisable.push(this.contentOrder.products[i])}
      }
    },
    checkDisableDropdown() {
      for (let r = 0; r < this.courseRegisters.length; r++) {
        const register = this.courseRegisters[r];
        this.courseRegisters[r].disable = _.some(this.listOrderDisable, (order) => {
          return order.productId == register.idTemp;
        })
      }
    },
    clickAddOrder(){},
    async checkVersionOrder() {
      this.loading = this.$loading.show()
      this.loadingInfinity = true;
      const respond = await OrderRepository.detail(this.$route.params.id);
      if(respond && respond.data) {
        this.versionOrder = respond.data.version;
        this.contactId = respond.data.contactId;
      }
        this.loadingInfinity = false;
        this.loading.hide();
    },
  }
};
</script>

<style scoped>
span.span-icon-custom {
  position: absolute;
  top: 15px;
  left: 20px;
}

.header-mobile {
  width: 100%;
  text-align: center;
}
.card-order {
  font-size: 16px;
  font-weight: 600;
}
.tab-order {
    display: flex;
    background: #F9EAE7;
    font-family: Roboto;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    height: 30px;
    border-radius: 4px;
    align-items: center;
}
.tab-item-order {
    height: 24px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    color: #6A2C62;
    cursor: pointer;
    width: 120px;
    justify-content: center;
}
.tab-item-order.active {
  background: #6A2C62;
  color: white;
}
.name-order {
    min-width: 200px;
}
</style>
